import React from 'react';
import { Wrench } from 'lucide-react';
import clsx from 'clsx';
import { ProjectScoping } from '../../types';
import { SectionHeader } from './SectionHeader';

interface ToolsSectionProps {
    tools: ProjectScoping['tools'];
    isDark: boolean;
    canEdit: boolean;
    onEdit: () => void;
}

const ToolCategory = ({ label, items, isDark, colorClass }: { label: string; items: string[]; isDark: boolean; colorClass: string }) => (
    <div>
        <div className="text-sm font-medium text-slate-500 mb-2">{label}</div>
        <div className="flex flex-wrap gap-2">
            {items.map((item, idx) => (
                <span key={idx} className={clsx('px-2 py-1 rounded text-xs', isDark ? `${colorClass}/30 text-${colorClass.split('-')[1]}-300` : `${colorClass.replace('-900', '-100')} text-${colorClass.split('-')[1]}-700`)}>
                    {item}
                </span>
            ))}
        </div>
    </div>
);

export const ToolsSection: React.FC<ToolsSectionProps> = ({ tools, isDark, canEdit, onEdit }) => (
    <div className={clsx('p-4 rounded-lg border', isDark ? 'bg-slate-800 border-slate-700' : 'bg-white border-slate-200')}>
        <SectionHeader icon={Wrench} colorClass="text-green-500" title="4. Tools (Methods & Resources)" onEdit={canEdit ? onEdit : undefined} canEdit={canEdit} isDark={isDark} />
        <div className="grid grid-cols-2 gap-4">
            <ToolCategory label="Software" items={tools.software} isDark={isDark} colorClass="bg-blue-900" />
            <ToolCategory label="Templates" items={tools.templates} isDark={isDark} colorClass="bg-green-900" />
            <ToolCategory label="Standards" items={tools.standards} isDark={isDark} colorClass="bg-purple-900" />
            <ToolCategory label="References" items={tools.references} isDark={isDark} colorClass="bg-orange-900" />
        </div>
    </div>
);
